import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function nonEmptyArrayValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value: unknown = control.value;

        return Array.isArray(value) && value.length > 0 ? null : { emptyArray: true };
    };
}
